import { renderRadioComponent } from '@ticketmaster/tm1pos-web-shared/components/RadioComponent';
import { EMAIL, PRINT, SMS } from '@ticketmaster/tm1pos-web-shared/constants';
import { FormattedMessage, type InjectedIntl, injectIntl } from 'react-intl';
import { Field } from 'redux-form/immutable';
import messages from '../../../../messages';

type DeliveryTypeControlsProps = {
  intl: InjectedIntl;
  emailAsDelivery: boolean;
};

const DeliveryTypeControlsComponent = (props: DeliveryTypeControlsProps) => {
  const { intl, emailAsDelivery } = props;

  const emailTab = emailAsDelivery ? (
    <li className="oc-radio-list__item">
      <Field
        name="deliveryMethod"
        component={renderRadioComponent}
        id="emailTickets"
        value={EMAIL}
        text={intl.formatMessage(messages.emailPlaceholder)}
        type="radio"
      />
    </li>
  ) : null;

  return (
    <>
      <div className="sdr-checkout__delivery-title-wrap">
        <div className="sdr-checkout__section-title">
          <FormattedMessage {...messages.ticketDeliveryAndReceipt} />
        </div>
      </div>
      <ul className="oc-radio-list oc-radio-list--toggle checkout-delivery-options">
        <li className="oc-radio-list__item">
          <Field
            name="deliveryMethod"
            component={renderRadioComponent}
            id="smsDelivery"
            value={SMS}
            text={intl.formatMessage(messages.smsDeliveryPlaceholder)}
            type="radio"
            checked
          />
        </li>
        {emailTab}
        <li className="oc-radio-list__item">
          <Field
            name="deliveryMethod"
            component={renderRadioComponent}
            id="printTickets"
            value={PRINT}
            text={intl.formatMessage(messages.printTicketsPlaceholder)}
            type="radio"
          />
        </li>
      </ul>
    </>
  );
};

export const DeliveryTypeControls = injectIntl(DeliveryTypeControlsComponent);
